import { __extends } from "tslib";
import { ArcRotateCameraPointersInput } from "../Cameras/Inputs/arcRotateCameraPointersInput";
import { ArcRotateCameraKeyboardMoveInput } from "../Cameras/Inputs/arcRotateCameraKeyboardMoveInput";
import { ArcRotateCameraMouseWheelInput } from "../Cameras/Inputs/arcRotateCameraMouseWheelInput";
import { CameraInputsManager } from "../Cameras/cameraInputsManager";
/**
 * Default Inputs manager for the ArcRotateCamera.
 * It groups all the default supported inputs for ease of use.
 * @see https://doc.babylonjs.com/how_to/customizing_camera_inputs
 */
var ArcRotateCameraInputsManager = /** @class */ (function (_super) {
    __extends(ArcRotateCameraInputsManager, _super);
    /**
     * Instantiates a new ArcRotateCameraInputsManager.
     * @param camera Defines the camera the inputs belong to
     */
    function ArcRotateCameraInputsManager(camera) {
        return _super.call(this, camera) || this;
    }
    /**
     * Add mouse wheel input support to the input manager.
     * @returns the current input manager
     */
    ArcRotateCameraInputsManager.prototype.addMouseWheel = function () {
        this.add(new ArcRotateCameraMouseWheelInput());
        return this;
    };
    /**
     * Add pointers input support to the input manager.
     * @returns the current input manager
     */
    ArcRotateCameraInputsManager.prototype.addPointers = function () {
        this.add(new ArcRotateCameraPointersInput());
        return this;
    };
    /**
     * Add keyboard input support to the input manager.
     * @returns the current input manager
     */
    ArcRotateCameraInputsManager.prototype.addKeyboard = function () {
        this.add(new ArcRotateCameraKeyboardMoveInput());
        return this;
    };
    return ArcRotateCameraInputsManager;
}(CameraInputsManager));
export { ArcRotateCameraInputsManager };
//# sourceMappingURL=arcRotateCameraInputsManager.js.map